import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200120SuSaSkAbschlussStatus: 'idle',
    startProcess200120SuSaSkAbschlussError: undefined as any,
    loadUserParamsProcess200120SuSaSkAbschlussStatus: 'idle',
    loadUserParamsProcess200120SuSaSkAbschlussError: undefined as any,

    process200120SuSaSkAbschlussList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200120SuSaSkAbschluss = createAsyncThunk('process200120SuSaSkAbschlussSlice/startProcess200120SuSaSkAbschluss', async ({ process200120SuSaSkAbschluss }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200120SuSaSkAbschluss/`,
        prepareData(process200120SuSaSkAbschluss),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200120SuSaSkAbschlussStatus } = getState().process200120SuSaSkAbschlussSlice
        return startProcess200120SuSaSkAbschlussStatus !== 'pending'
    }
})

export const loadUserParamsProcess200120SuSaSkAbschluss = createAsyncThunk('process200120SuSaSkAbschlussSlice/loadUserParamsProcess200120SuSaSkAbschluss', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200120SuSaSkAbschluss/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200120SuSaSkAbschlussStatus } = getState().process200120SuSaSkAbschlussSlice
        return loadUserParamsProcess200120SuSaSkAbschlussStatus !== 'pending'
    }
})

const Process200120SuSaSkAbschlussSlice = createSlice({
    name: 'process200120SuSaSkAbschlussSlice',
    initialState,
    reducers: {
        resetstartProcess200120SuSaSkAbschluss: (state) => {
            state.job = undefined
            state.startProcess200120SuSaSkAbschlussError = undefined
        },
        resetstartProcess200120SuSaSkAbschlussError: (state) => {
            state.startProcess200120SuSaSkAbschlussError = undefined
        },
        resetloadUserParamsProcess200120SuSaSkAbschluss: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200120SuSaSkAbschlussError = undefined
        },
        resetloadUserParamsProcess200120SuSaSkAbschlussError: (state) => {
            state.loadUserParamsProcess200120SuSaSkAbschlussError = undefined
        },
        removeFromProcess200120SuSaSkAbschlussListById: (state, action) => {
            state.process200120SuSaSkAbschlussList = state.process200120SuSaSkAbschlussList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200120SuSaSkAbschlussListByIds: (state, action) => {
            state.process200120SuSaSkAbschlussList = state.process200120SuSaSkAbschlussList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200120SuSaSkAbschlussList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200120SuSaSkAbschlussStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200120SuSaSkAbschlussList = []
            state.startProcess200120SuSaSkAbschlussStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200120SuSaSkAbschluss.pending, (state) => {
            state.startProcess200120SuSaSkAbschlussStatus = 'pending'
            state.startProcess200120SuSaSkAbschlussError = undefined
        })
        builder.addCase(startProcess200120SuSaSkAbschluss.fulfilled, (state, action) => {
            state.startProcess200120SuSaSkAbschlussStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200120SuSaSkAbschluss.rejected, (state, action) => {
            state.startProcess200120SuSaSkAbschlussStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200120SuSaSkAbschlussError = action.error.message
            } else {
                state.startProcess200120SuSaSkAbschlussError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200120SuSaSkAbschluss.pending, (state) => {
            state.loadUserParamsProcess200120SuSaSkAbschlussStatus = 'pending'
            state.loadUserParamsProcess200120SuSaSkAbschlussError = undefined
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkAbschluss.fulfilled, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkAbschlussStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkAbschluss.rejected, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkAbschlussStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200120SuSaSkAbschlussError = action.error.message
            } else {
                state.loadUserParamsProcess200120SuSaSkAbschlussError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200120SuSaSkAbschluss,
    resetstartProcess200120SuSaSkAbschlussError,
    resetloadUserParamsProcess200120SuSaSkAbschluss,
    resetloadUserParamsProcess200120SuSaSkAbschlussError,
    removeFromProcess200120SuSaSkAbschlussListById,
    removeFromProcess200120SuSaSkAbschlussListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200120SuSaSkAbschlussSlice.actions
export default Process200120SuSaSkAbschlussSlice.reducer
